import React from 'react'
import Container from '../../../../components/Container'
import { FormCreatePerImportHiring } from '../components/FormCreatePerImport'
import { nameActions } from '../domain/info'
import { toolsCreate } from '../domain/tools/create'
import { breadcrumbCreate } from '../domain/breadcrumb'

const Import = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormCreatePerImportHiring typeForm="create" />
  </Container>
)

export default Import
